import * as React from "react";
import type { SVGProps } from "react";
const SvgIconEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.98 1.07q-.23.04-.47.13c-.26.11-.32.17-1.35 1.2L6.82 5.7c-3.14 3.12-3 2.98-3.05 3.08-.04.08-.08.33-.31 1.75-.22 1.32-.28 1.68-.27 1.76.02.27.24.5.51.52.08 0 .4-.04 1.68-.27l1.67-.3.17-.07c.07-.04 7.14-7.09 7.3-7.27.25-.3.37-.56.4-.92.05-.4-.06-.81-.3-1.14l-.75-.77c-.69-.68-.79-.76-1.04-.87s-.6-.16-.85-.13m.04 1.16-.1.05c-.06.04-3.25 3.2-5.99 5.93L4.82 9.3l-.19 1.11-.17 1.11 1.1-.19 1.1-.2 3.52-3.52c2.76-2.76 3.54-3.54 3.57-3.6q.08-.18 0-.38c-.02-.1-.06-.13-.65-.72-.7-.7-.7-.7-.9-.7zM1.5 13.8q-.15.04-.27.16c-.1.1-.13.17-.16.3-.05.3.15.6.46.66.13.02 12.81.02 12.94 0q.28-.07.4-.32c.04-.08.05-.11.05-.24s0-.17-.04-.24q-.13-.27-.43-.32c-.15-.03-12.84-.02-12.95 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconEdit;
